import { Pipe, PipeTransform } from '@angular/core';
import { ISegment, ISegmentInformation } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Pipe({
    name: 'sortSegment'
})

export class SortSegmentPipe implements PipeTransform {
    public transform(segmentItem: ISegment): string[] {
        // #33311 : filtering journeyArray on segmentItem so items equals segments
        const {xId, seat, journey, journeyArray, ...items}: ISegment = segmentItem;

        return Object.entries(items)
            .sort((a: [string, ISegmentInformation], b: [string, ISegmentInformation]) => {
                return a[1].begin.localeCompare(b[1].begin);
            })
            .map((value: [string, ISegmentInformation]) => value[0]);
    }
}
